var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavTheta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000",
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-110.34 -219.62)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 110.51 218.64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.9 27.7c0.3 1.5 0.4 3 0.4 4.4 0 7.1-1.7 12.9-5.2 17.5s-7.8 6.9-13.1 6.9c-7.9 0-14.2-5.8-16.2-11.3l5.6-6.4c0.2 3.3 1.1 6.4 2.7 9.3 2 3.8 4.7 5.8 8.2 5.8 3.3 0 5.9-2 7.9-5.9 1.7-3.5 2.7-6.8 2.9-12.5zm0.5-6.5-1.3-1.1 7.4-3.2-2.2 7.7-1.7-1.4-10.7 12.4-0.1 0.1c-0.1 0.2-0.3 0.3-0.5 0.4-0.7 0.3-1.4 0.1-1.9-0.4l-3.4-3.9-5.5 6.3-0.2 0.2c-0.2 0.2-0.4 0.4-0.7 0.5-0.6 0.2-1.2 0-1.6-0.5l-3.5-4.1-10.5 11.8-2-2.2 11.2-12.7c0.3-0.3 0.8-0.5 1.3-0.5 0.2 0 0.5 0.1 0.7 0.2s0.3 0.2 0.4 0.3l0.2 0.2 3.4 3.9 5.6-6.5c0.3-0.3 0.6-0.5 1-0.5h0.2c0.4 0 0.8 0.2 1 0.4l0.1 0.1 3.4 3.9zm-35.8 18.6c-0.5-2.4-0.7-4.9-0.7-7.3 0-7.3 1.7-13.2 5.1-17.8s7.8-6.9 13.1-6.9c5.2-0.1 10.1 2.4 13.1 6.7 1.8 2.4 3.1 4.1 3.9 7.2l-6.1 7c-0.2-5.8-1.2-9.2-2.9-12.6-2-3.8-4.7-5.8-8.2-5.8-3.3 0-5.9 1.9-7.9 5.8-1.9 3.9-2.9 9.2-2.9 16v0.1z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTheta);
export default __webpack_public_path__ + "static/media/nav-theta.d90fabb46f304e5c5126c45913488f51.svg";
export { ForwardRef as ReactComponent };